module.exports = new __parcel__URL__("18811_h.d438b897.jpg").toString();